import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, createRoutesFromElements, Outlet, Route, useLocation } from 'react-router-dom';

// styles
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/css/elementor_style.css';
import './assets/css/swiper-bundle.min.css';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/spartan.css';
import './assets/sass/style.scss';

// pages
import About from './Pages/About';
import Contact from './Pages/Contact';
import Error404 from './Pages/Error404';
import Home1 from './Pages/Home1';
import OurWork from './Pages/OurWork';
import Services from './Pages/Services';
import Careers from './Pages/Careers'
import Preloader from './components/Misc/Preloader';
import Navbar from './components/Navs/Navbar';
import Footer from './components/Misc/Footer';

// Work Sections
import ProjectDetails from './Pages/Work/ProjectDetails';

import { initializePage } from './utils';

import ScrollToTop from './components/Misc/ScrollToTop';

const GA_MEASUREMENT_ID = 'G-F8QDDGGRNG';

const GoogleAnalyticsTracker = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (typeof window.gtag !== 'function') return;

        const pagePath = `${pathname}${search}`;

        window.gtag('event', 'page_view', {
            page_title: document.title,
            page_path: pagePath,
            page_location: `${window.location.origin}${pagePath}`,
            send_to: GA_MEASUREMENT_ID,
        });
    }, [pathname, search]);

    return null;
};

const Layout = () => {
    return (
        <>
            <GoogleAnalyticsTracker />
            <Preloader />
            <ScrollToTop />
            <Navbar />
            <main id="main-content">
                <Outlet />
            </main>
            <Footer />
        </>
    );
};

const router = createBrowserRouter(
    createRoutesFromElements(
            <Route path="/" element={<Layout />}>
            <Route path="/" element={<Home1 />} />
            <Route path="*" element={<Error404 />} />
            <Route path="/About" element={<About />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/OurWork" element={<OurWork />} />
            <Route path="/Careers" element={<Careers />} />

            {/* Work Sections */}
            <Route path="/OurWork/:slug" element={<ProjectDetails />} />
        </Route>
    ),
    {
        basename: "/",
    }
);

export default function App() {
    useEffect(initializePage, []);

    return (
        <div className="App">
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </div>
    );
}
